<div class="changes-dialog">
  <div class="changes-dialog-header">
    <h2 class="changes-dialog-title mb-0" mat-dialog-title>{{ data.header }}</h2>
  </div>
  <mat-dialog-content class="changes-content">
    <table class="changes-table" *ngIf="data.changesList?.length; else noChanges">
      <thead>
        <tr>
          <th>Fields</th>
          <th>Content Changed</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let change of data.changesList">
          <td>{{ getChangeKey(change) }}</td>
          <td>{{ getChangeValue(change) }}</td>
        </tr>
      </tbody>
    </table>
    <ng-template #noChanges>
      <div class="no-changes">No fields were modified</div>
    </ng-template>
  </mat-dialog-content>
  <div class="changes-dialog-footer">
    <button type="button" class="btn-close-dialog" (click)="close()">Close</button>
  </div>
</div>